module.exports = __webpack_public_path__ + "img/dropdown.a843462d.svg";